export default "__VITE_ASSET__DgEkoMNM__"